import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import Home from "components/pages/home/Home";
import Community from "components/pages/community/main/Community";
import DetailCommunity from "components/pages/community/detail/DetailCommunity";
import DashboardDetail from "components/pages/dashboard/detail/DashboardDetail";
import DashboardSearch from "components/pages/dashboard/search/DashboardSearch";
import DashboardSearchMonthTrend from "components/pages/dashboard/search/DashboardSearchMonthTrend";
import CreatePost from "./components/pages/community/create/CreatePost";
import DashboardSearchInput from "components/pages/dashboard/search/DashboardSearchInput";
import BottomNavigation from "components/common/navigation/bottomNavigation";
import UpdatePost from "components/pages/community/update/UpdatePost";
import AccusePost from "components/pages/community/accuse/AccusePost";
import AccuseComment from "components/pages/community/accuse/AccuseComment";
import AccuseRecomment from "components/pages/community/accuse/AccuseRecomment";
import SearchPost from "components/pages/community/search/SearchPost";
import Login from "components/pages/login/Login";
import Kakao from "components/pages/login/Kakao";
import Logout from "components/pages/login/Logout";
import Alarm from "components/pages/alarm/Alarm";
import CreateRecomment from "components/pages/community/detail/createRecomment/CreateRecomment";
import Agreement from "components/pages/login/Agreement";
import Signup from "components/pages/login/Signup";
import Uncertificated from "components/pages/login/Uncertificated";
import MarketHome from "components/pages/market/home/MarketHome";
import Feed from "./components/pages/myPage/feed/Feed";
import MarketDetail from "components/pages/market/detail/MarketDetail";
import MarketFlowerList from "components/pages/market/detail/MarketFlowerList";
import MarketFlowerPreview from "components/pages/market/detail/MarketFlowerPreview";
import Secession from "components/pages/myPage/Secession";

import ServiceIntro from "components/pages/home/ServiceIntro";
import CommunityGuideLine from "components/pages/home/CommunityGuideLine";
import MarketSearch from "components/pages/market/search/MarketSearch";
import MarketLikeList from "components/pages/market/home/MarketLikeList";
import MarketRegistration from "components/pages/market/detail/MarketRegistration";
import UpdateInfo from "components/pages/myPage/updateProfile/UpdateInfo";
import Mypage from "components/pages/myPage/mypage/Mypage";
import Setting from "components/pages/myPage/setting/Setting";
import Tos from "components/pages/login/Tos";
import AgreementContents from "components/pages/login/AgreementContents";

import PrivacyPolicy from "components/pages/home/PrivacyPolicy";
import InfoProvision from "components/pages/home/InfoProvision";
function App() {
  return (
    <div className="page_wrapper">
      <div className="page_flexbox">
        <div className="background-text"></div>
        <div className="page_container">
          <div id="page_section">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/info-provision" element={<InfoProvision />} />

              <Route path="/intro" element={<ServiceIntro />} />
              <Route path="/community-guide" element={<CommunityGuideLine />} />
              <Route path="/alarm" element={<Alarm />} />
              <Route path="/login" element={<Login />} />
              <Route path="/users/*" element={<Kakao />} />
              <Route path="/logout" element={<Logout />} />
              <Route path="/signup/agreement" element={<Agreement />} />
              <Route path="/signup/agreement/:type" element={<AgreementContents />} />
              <Route path="/signup" element={<Signup />} />
              <Route
                path="/signup/uncertificated"
                element={<Uncertificated />}
              />
              <Route path="/notice/:type" element={<Tos />} />

              {/* <Route path="/dashboard" element={<ServicePage />} /> */}
              <Route path="/dashboard" element={<DashboardSearch />} />
              <Route
                path="/dashboard/:name/:page"
                element={<DashboardSearchMonthTrend />}
              />
              <Route
                path="/dashboard/search"
                element={<DashboardSearchInput />}
              />

              <Route
                path="/dashboard/:f_id/:f_type/:f_name/:pred_p/:pred_b"
                element={<DashboardDetail />}
              />

              <Route path="/boards" element={<Community />} />
              <Route path="/boards/:boardId" element={<DetailCommunity />} />
              <Route path="/boards/createpost" element={<CreatePost />} />
              <Route path="/boards/update/:boardId" element={<UpdatePost />} />
              <Route path="/boards/:boardId/report" element={<AccusePost />} />
              <Route
                path="/boards/:boardId/comments/:commentId"
                element={<CreateRecomment />}
              />
              <Route
                path="/boards/:boardId/comments/:commentId/report"
                element={<AccuseComment />}
              />
              <Route
                path="/boards/:boardId/comments/:commentId/recomments/:recommentId/report"
                element={<AccuseRecomment />}
              />
              <Route path="/boards/search" element={<SearchPost />} />

              <Route path="/market" element={<MarketHome />} />
              <Route path="/market/:marketId" element={<MarketDetail />} />
              <Route
                path="/market/:marketId/:type"
                element={<MarketFlowerList />}
              />
              <Route
                path="/market/image-preview"
                element={<MarketFlowerPreview />}
              />
              <Route path="/market/LikeList" element={<MarketLikeList />} />
              <Route path="/market/search" element={<MarketSearch />} />
              <Route
                path="/market/Registration/:marketId"
                element={<MarketRegistration />}
              />

              {/* 마이페이지 */}
              <Route path="/mypage" element={<Mypage />} />
              <Route path="/mypage/feed" element={<Feed />} />
              <Route path="/mypage/secession" element={<Secession />} />
              <Route path="/mypage/edit" element={<UpdateInfo />} />
              <Route path="/mypage/setting" element={<Setting />} />
            </Routes>
          </div>
          <BottomNavigation />
        </div>
      </div>
    </div>
  );
}

export default App;
